import { EmploymentStatus } from 'api/SmallLoanProgram/EmploymentsApi';

export const EmploymentStatusName: Record<EmploymentStatus, string> = {
  [EmploymentStatus.EmployedW2]: 'W2',
  [EmploymentStatus.SelfEmployed]: 'Self-employed',
  [EmploymentStatus.VaDisability]: 'VA Disability',
  [EmploymentStatus.MilitaryPension]: 'Military Pension',
  [EmploymentStatus.EmployerPension]: 'Employer Pension',
  [EmploymentStatus.SocialSecurity]: 'Social Security',
  [EmploymentStatus.RentalIncome]: 'Rental Income',
  [EmploymentStatus.Other]: 'Other',
};

export enum PrimaryEmploymentFieldNames {
  HireDate = 'primary_employment_hire_date',
  Position = 'primary_employment_position',
  BusinessName = 'primary_employment_business_name',
}

export enum PreviousEmploymentFieldNames {
  BusinessName = 'previous_employment_business_name',
  Position = 'previous_employment_position',
  HireDate = 'previous_employment_hire_date',
}
